import React, { FC } from 'react';
import { MotifSearch } from '@ey-xd/motif-react';
import { MotifFormField } from '@ey-xd/motif-react';

import './Search.scss';

type SearchProps = {
    className?: string;
    id?: string;
    hideClearButton?: boolean;
    disabled?: boolean;
    searchButtonTitle?: string;
    placeholder?: string;
    value?: string;
    style?: object;
    items?: any;
    ref?: any;
    onSearchButtonClick?: (...args: void[]) => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSelect?: (e: any) => void;
    onEnter?: (...args: void[]) => void;
    onBlur?: (...args: void[]) => void;
};
const Search: FC<SearchProps> = ({
    className,
    id,
    hideClearButton,
    disabled,
    searchButtonTitle,
    placeholder,
    value,
    style,
    ref,
    onSearchButtonClick,
    onChange,
    onSelect,
    onEnter,
    onBlur,
    ...other
}: SearchProps) => (
    <MotifFormField>
        <MotifSearch
            className={className}
            id={id}
            hideClearButton={hideClearButton}
            disabled={disabled}
            searchButtonTitle={searchButtonTitle}
            onSearchButtonClick={onSearchButtonClick}
            onChange={onChange}
            onSelect={onSelect}
            placeholder={placeholder}
            onEnter={onEnter}
            onBlur={onBlur}
            value={value}
            style={style}
            ref={ref}
            {...other}
        />
    </MotifFormField>
);
export default Search;
